import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="absolute left-1/2 top-10 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-md bg-primary-500 text-background-50">
        <i className="ri-fire-fill text-xl" />
      </span>
      <h1 className="font-heading text-7xl font-black text-primary-400 md:text-9xl">404</h1>
      <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        迷路到忍界边缘了
      </h2>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-400">
        你访问的页面「{location.pathname}」不存在或已被移除。回到作品库，继续你的追更之旅吧。
      </p>
      <Link
        to="/"
        className="mt-8 flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
      >
        <i className="ri-home-4-line" />
        返回首页
      </Link>
      <Link to="/works" className="mt-3 text-sm text-foreground-400 transition-colors hover:text-primary-300 whitespace-nowrap">
        前往同人作品库 →
      </Link>
    </div>
  );
}